import axios from 'axios';
//  专门用来展示静态HTML文件的组件
const Html = {
  template: '<div v-html="html"></div>',
  data: () => ({
    html: ''
  }),
  beforeRouteEnter(to, from, next) {
    axios.get('/static/html/' + to.params.file).then(response => {
      next(vm => {
        vm.html = response.data;
        vm.$nextTick(() => vm.$emit('loaded'));
      });
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.$emit('loaded', 1);
    axios.get('/static/html/' + to.params.file).then(response => {
      this.html = response.data;
      this.$nextTick(() => {
        this.$emit('loaded', 0);
        next();
      });
    });
  }
};

export const route = [
  {
    path: '/',
    component: () => import('./components/index.vue'),
    children: [
      {
        path: '/base',
        component: () => import('./components/common/parent-route.vue'),
        meta: {moduleId: 'base', title: '基础资料', icon: 'base', perm: 'base-data-manager'},
        children: [
          {
            path: '/base/info',
            component: () => import('./components/base/info/detail.vue'),
            meta: {moduleId: 'base', title: '我的单位', perm: 'own-business-query'}
          },
          {
            path: '/base/logistics',
            component: () => import('./components/base/logistics/index.vue'),
            meta: {
              moduleId: 'base', title: '我的物流中心', perm: 'org-logistics-query', pagerPerm: {
                add: "'org-logistics-add",
                edit: 'org-logistics-edit',
                delete: 'org-logistics-delete',
                addWarehouse: 'org-warehouse-add',
                editWarehouse: 'org-warehouse-edit',
                delWarehouse: 'org-warehouse-delete',
                queryDev: 'org-warehouse-dev-query'
              }
            },
            children: []
          },
          {
            path: '/base/org',
            component: () => import('./components/base/org/list.vue'),
            meta: {moduleId: 'base', title: '单位信息', perm: 'mdm-business-unit'}
          },
          {
            path: '/base/org/biz',
            component: () => import('./components/base/operating-org/org.vue'),
            meta: {moduleId: 'base', title: '往来单位', perm: 'mdm-operating-org-watch'}
          },
          {
            path: '/base/main/goods',
            component: () => import('./components/base/product/productmanage.vue'),
            meta: {moduleId: 'base', title: '货品主档', perm: 'mdm-goods-manager'}
          },
          {
            path: '/base/main/operating/goods',
            component: () => import('./components/base/operating-goods/goods.vue'),
            meta: {moduleId: 'base', title: '经营货品', perm: 'mdm-operating-goods-watch'}
          },
          {
            path: '/base/batch/number',
            component: () => import('./components/base/batch/index.vue'),
            meta: {moduleId: 'base', title: '批号管理', perm: 'code-batch-number-query'}
          }
        ]
      },
      {
        path: '/order',
        component: () => import('./components/common/parent-route.vue'),
        meta: {moduleId: 'order', title: '订单服务', icon: 'order', perm: 'bsp-order-manager'},
        children: [
          {
            path: '/order/org/in/need',
            component: () => import('./components/order/index.vue'),
            meta: {
              moduleId: 'order', title: '要货需求', perm: 'bsp-in-order-org-need', type: 0,
              role: 'org', pagerPerm: {}, isNeed: true
            }
          },
          {
            path: '/order/org/out/purchase/return',
            component: () => import('./components/order/index.vue'),
            meta: {
              moduleId: 'order', title: '退货需求', perm: 'bsp-in-order-return', type: 1,
              role: 'org', pagerPerm: {}, isPurchaseReturn: true
            }
          },
          {
            path: '/order/org/purchase/in',
            component: () => import('./components/order/index.vue'),
            meta: {
              moduleId: 'order',
              title: '采购入库',
              perm: 'bsp-in-order-org-query-purchase-in',
              bizType: '1-0',
              type: 0,
              role: 'org',
              pagerPerm: {
                add: 'bsp-in-order-org-add',
                edit: 'bsp-in-order-org-edit'
              }
            }
          },
          {
            path: '/order/org/sale/return',
            component: () => import('./components/order/index.vue'),
            meta: {
              moduleId: 'order',
              title: '销售退货',
              perm: 'bsp-in-order-org-query-sale-return',
              bizType: '1-1',
              type: 0,
              role: 'org',
              pagerPerm: {
                add: 'bsp-in-order-org-add',
                edit: 'bsp-in-order-org-edit'
              }
            }
          },
          {
            path: '/order/org/full/in',
            component: () => import('./components/order/index.vue'),
            meta: {
              moduleId: 'order',
              title: '盘盈入库',
              perm: 'bsp-in-order-org-query-full-in',
              bizType: '1-2',
              type: 0,
              role: 'org',
              pagerPerm: {
                add: 'bsp-in-order-org-add',
                edit: 'bsp-in-order-org-edit'
              }
            }
          },
          {
            path: '/order/org/allot/in',
            component: () => import('./components/order/index.vue'),
            meta: {
              moduleId: 'order',
              title: '调拨入库',
              perm: 'bsp-in-order-org-query-allot-in',
              bizType: '1-3',
              type: 0,
              role: 'org',
              pagerPerm: {
                add: 'bsp-in-order-org-add',
                edit: 'bsp-in-order-org-edit'
              }
            }
          },
          {
            path: '/order/org/product/in',
            component: () => import('./components/order/index.vue'),
            meta: {
              moduleId: 'order',
              title: '成品入库',
              perm: 'bsp-in-order-org-query-product-in',
              bizType: '1-4',
              type: 0,
              role: 'org',
              pagerPerm: {
                add: 'bsp-in-order-org-add',
                edit: 'bsp-in-order-org-edit'
              }
            }
          },

          {
            path: '/order/org/sale/out',
            component: () => import('./components/order/index.vue'),
            meta: {
              moduleId: 'order',
              title: '销售出库',
              perm: 'bsp-out-order-org-query-sale-out',
              bizType: '2-0',
              type: 1,
              role: 'org',
              pagerPerm: {
                add: 'bsp-out-order-org-add',
                edit: 'bsp-out-order-org-edit',
                batchConfirm: 'bsp-order-org-batch-confirm',
              }
            }
          },
          {
            path: '/order/org/purchase/out',
            component: () => import('./components/order/index.vue'),
            meta: {
              moduleId: 'order',
              title: '采购退货',
              perm: 'bsp-out-order-org-query-purchase-out',
              bizType: '2-1',
              type: 1,
              role: 'org',
              pagerPerm: {
                add: 'bsp-out-order-org-add',
                edit: 'bsp-out-order-org-edit'
              }
            }
          },
          {
            path: '/order/org/loss/out',
            component: () => import('./components/order/index.vue'),
            meta: {
              moduleId: 'order', title: '盘亏出库', perm: 'bsp-out-order-org-query-loss-out',
              bizType: '2-2', type: 1, role: 'org', pagerPerm: {
                add: 'bsp-out-order-org-add',
                edit: 'bsp-out-order-org-edit'
              }
            }
          },
          {
            path: '/order/org/allot/out',
            component: () => import('./components/order/index.vue'),
            meta: {
              moduleId: 'order',
              title: '调拨出库',
              perm: 'bsp-out-order-org-query-allot-out',
              bizType: '2-3',
              type: 1,
              role: 'org',
              pagerPerm: {
                add: 'bsp-out-order-org-add',
                edit: 'bsp-out-order-org-edit'
              }
            }
          },
          {
            path: '/order/org/break/out',
            component: () => import('./components/order/index.vue'),
            meta: {
              moduleId: 'order',
              title: '报损',
              perm: 'bsp-out-order-org-query-break-out',
              bizType: '2-4',
              type: 1,
              role: 'org',
              pagerPerm: {
                add: 'bsp-out-order-org-add',
                edit: 'bsp-out-order-org-edit'
              }
            }
          },
          {
            path: '/order/org/in/detail',
            component: () => import('./components/goods-detail/index.vue'),
            meta: {moduleId: 'order', title: '入库明细', perm: 'bsp-in-receipt-org-manager', type: 0, role: 'org'}
          },
          {
            path: '/order/org/out/detail',
            component: () => import('./components/goods-out-detail/index.vue'),
            meta: {moduleId: 'order', title: '出库明细', perm: 'bsp-out-receipt-org-manager', type: 1, role: 'org'}
          }
        ]
      },
      {
        path: '/logistics',
        component: () => import('./components/common/parent-route.vue'),
        meta: {moduleId: 'logistics', title: '物流服务', icon: 'delivery', perm: 'logistics-bsp-order-manager'},
        children: [

          {
            path: '/logistics/org/in',
            component: () => import('./components/logistics/index.vue'),
            meta: {
              moduleId: 'logistics',
              title: '入库订单',
              perm: 'logistics-bsp-in-order-org-query',
              type: 0,
              role: 'org',
              pagerPerm: {
                add: 'logistics-bsp-in-order-org-add',
                edit: 'bsp-in-order-org-edit'
              }
            }
          },
          {
            path: '/logistics/org/out',
            component: () => import('./components/logistics/index.vue'),
            meta: {
              moduleId: 'logistics',
              title: '出库订单',
              perm: 'logistics-bsp-out-order-org-query',
              type: 1,
              role: 'org',
              pagerPerm: {
                add: 'logistics-bsp-out-order-org-add',
                edit: 'bsp-out-order-org-edit'
              }
            }
          }
        ]
      },
      {
        path: '/retrospect',
        component: () => import('./components/common/parent-route.vue'),
        meta: {moduleId: 'retrospect', title: '追溯码管理', icon: 'codes', perm: 'code-data-manager'},
        children: [
          {
            path: '/retrospect/xml/batch-import',
            component: () => import('./components/upload/batch-import/import.vue'),
            meta: {moduleId: 'retrospect', title: '源文件批量上传', perm: 'codes-file-batch-upload'}
          },
          {
            path: '/retrospect/goods/import/:id',
            component: () => import('./components/upload/import/import.vue'),
            meta: {moduleId: 'retrospect', title: '源文件上传', perm: 'codes-file-query', type: 1}
          },
          {
            path: '/retrospect/goods/my',
            component: () => import('./components/goods/my.vue'),
            meta: {moduleId: 'retrospect', title: '我的产品', perm: 'goods-manager-my'}
          },
          {
            path: '/retrospect/goods/apply/:id',
            component: () => import('./components/upload/import/apply.vue'),
            meta: {moduleId: 'retrospect', title: '追溯码申请', perm: 'traceCode-data-apply', type: 0}
          },
          {
            path: '/retrospect/goods/replace/:id',
            component: () => import('./components/upload/import/replace.vue'),
            meta: {moduleId: 'retrospect', title: '追溯码替换', perm: 'traceCode-data-replace', type: 0}
          },
          {
            path: '/retrospect/goods/cancel/:id',
            component: () => import('./components/upload/import/cancel.vue'),
            meta: {moduleId: 'retrospect', title: '追溯码注销', perm: 'traceCode-data-cancel', type: 0}
          },
          {
            path: '/retrospect/goods/relatedDelete/:id',
            component: () => import('./components/upload/import/relatedDelete.vue'),
            meta: {moduleId: 'retrospect', title: '关联关系删除', perm: 'traceCode-data-relation-delete', type: 0}
          },
          {
            path: '/retrospect/exception/import/:id',
            component: () => import('./components/upload/exception-code/import.vue'),
            meta: {moduleId: 'retrospect', title: '异常码标记', perm: 'exception-codes-file-query'}
          },
          // {
          //   path: '/retrospect/business/import/:id',
          //   component: () => import('./components/search/business/index-upload.vue'),
          //   meta: {moduleId: 'retrospect', title: '业务追溯上传', perm: 'biz-codes-file-query', isUpload: true},
          //   children: [
          //     {
          //       path: '',
          //       component: () => import('./components/search/business/index-upload.vue'),
          //       meta: {moduleId: 'retrospect', title: '业务追溯上传', perm: 'biz-codes-file-query'}
          //     },
          //     {
          //       path: '/retrospect/business/batch-add',
          //       component: () => import('./components/search/business/form/batchAddALiForm.vue'),
          //       meta: {moduleId: 'retrospect', title: '业务追溯上传', perm: 'biz-codes-file-query'}
          //     }
          //   ]
          // },
          {
            path: '/retrospect/business/import/:id',
            component: () => import('./components/common/parent-route.vue'),
            meta: {moduleId: 'retrospect', title: '业务追溯上传', perm: 'biz-codes-file-query', subMenuId: 'retrospect'},
            children: [
              {
                path: '',
                component: () => import('./components/search/business/index-upload.vue'),
                meta: {moduleId: 'retrospect', title: '业务追溯上传', perm: 'biz-codes-file-query'}
              },
              {
                path: '/retrospect/business/batch-add',
                component: () => import('./components/search/business/form/batchAddALiForm.vue'),
                meta: {moduleId: 'retrospect', title: '业务追溯上传', perm: 'biz-codes-file-query'}
              }
            ]
          },
          {
            path: '/retrospect/rule/arguments',
            component: () => import('./components/upload/code-rule/index.vue'),
            meta: {moduleId: 'retrospect', title: 'GS1结构管理', perm: 'gs1-rule-query', isUpload: true}
          },
          {
            path: '/retrospect/electronCode/construction',
            component: () => import('./components/electronCode/construction/goods.vue'),
            meta: {moduleId: 'retrospect', title: '电子监管码结构管理', perm: 'electron-code-rule-query', isUpload: true}
          }
        ]
      },
      {
        path: '/search',
        component: () => import('./components/common/parent-route.vue'),
        meta: {moduleId: 'search', title: '追溯查询', icon: 'search', perm: 'code-trace-manager'},
        children: [
          {
            path: '/search/code/:id',
            component: () => import('./components/search/code/index.vue'),
            meta: {moduleId: 'search', title: '追溯码追溯查询', perm: 'single-code-trace-query', subMenuId: 'code'}
          },
          {
            path: '/search/child/code',
            component: () => import('./components/search/child-code/replace.vue'),
            meta: {moduleId: 'search', title: '追溯码子码查询', perm: 'child-code-trace-query', type: 0}
          },
          {
            path: '/search/business',
            component: () => import('./components/search/business/index.vue'),
            meta: {moduleId: 'search', title: '业务追溯查询', perm: 'code-biz-trace-view'}
          },
          {
            path: '/search/business-in',
            component: () => import('./components/search/business-in/index.vue'),
            meta: {moduleId: 'search', title: '入库单追溯', perm: 'code-biz-in-trace-view'}
          },
          {
            path: '/search/business-out',
            component: () => import('./components/search/business-out/index.vue'),
            meta: {moduleId: 'search', title: '出库单追溯', perm: 'code-biz-out-trace-view'}
          },
          {
            path: '/search/use',
            component: () => import('./components/search/use-record/index.vue'),
            meta: {moduleId: 'search', title: '终端使用/销售记录', perm: 'code-injection-trace'}
          },
          {
            path: '/search/goods',
            component: () => import('./components/search/goods/index.vue'),
            meta: {moduleId: 'search', title: '实物追溯查询', perm: 'physical-goods-trace-query', subMenuId: 'goods'},
            children: [
              {
                path: '',
                component: () => import('./components/search/goods/list/index.vue'),
                meta: {moduleId: 'search'}
              },
              {
                path: '/search/goods/:id',
                component: () => import('./components/search/goods/single/index.vue'),
                meta: {moduleId: 'search'}
              }
            ]
          },
          {
            path: '/search/company',
            component: () => import('./components/search/batch-new-company/index.vue'),
            meta: {moduleId: 'search', title: '流转分布追溯查询', perm: 'batch-number-trace', subMenuId: 'company'},
            children: [
              {
                path: '',
                component: () => import('./components/search/batch-new-company/list/index.vue'),
                meta: {moduleId: 'search'}
              },
              {
                path: '/search/company/:id',
                component: () => import('./components/search/batch-new-company/single/index.vue'),
                meta: {moduleId: 'search'}
              }
            ]
          }
          // {
          //   path: '/search/exception',
          //   component: () => import('./components/search/exception/index.vue'),
          //   meta: {moduleId: 'search', title: '异常事件追溯', perm: 'show'}
          // }
        ]
      },
      {
        path: '/report',
        component: () => import('./components/common/parent-route.vue'),
        meta: {moduleId: 'store', title: '库存管理', icon: 'report', perm: 'bsp-stock-manager'},
        children: [
          {
            path: '/store/org/batchNumber',
            component: resolve => require(['./components/report/index.vue'], resolve),
            meta: {moduleId: 'store', title: '批号库存', perm: 'bsp-stock-org-query', type: 'batchNumber', role: 'org'}
          },
          {
            path: '/store/org/batch',
            component: resolve => require(['./components/report/index.vue'], resolve),
            meta: {moduleId: 'store', title: '批次库存', perm: 'bsp-stock-batch-org-query', type: 'batch', role: 'org'}
          },
          {
            path: '/store/flow',
            component: resolve => require(['./components/report/index.vue'], resolve),
            meta: {moduleId: 'store', title: '即时库存流向', perm: 'bsp-stock-batch-org-flow', type: 'flow', role: 'org'}
          },
          {
            path: '/store/adjust',
            component: () => import('./components/common/parent-route.vue'),
            meta: {moduleId: 'store', title: '库存调整', perm: 'bsp-stock-org-adjust-query', subMenuId: 'operate'},
            children: [
              {
                path: '',
                component: () => import('./components/report/adjust-count-stock-records.vue'),
                meta: {moduleId: 'store', title: '库存调整', perm: 'bsp-stock-org-query'}
              },
              {
                path: '/store/operate/adjust',
                component: () => import('./components/report/adjust-count-stock.vue'),
                meta: {moduleId: 'store', title: '库存调整', perm: 'bsp-stock-org-query'}
              },
            ]
          },
          {
            path: '/store/report',
            component: resolve => require(['./components/reportInventory/index.vue'], resolve),
            meta: {moduleId: 'store', title: '上报库存', perm: 'report-inventory-query'}
          },
          {
            path: '/store/confirm',
            component: resolve => require(['./components/confirmInventory/index.vue'], resolve),
            meta: {moduleId: 'store', title: '待验库存', perm: 'report-confirm-query'}
          }
        ]
      },
      {
        path: '/system',
        component: () => import('./components/common/parent-route.vue'),
        meta: {moduleId: 'system', title: '系统管理', icon: 'sys-setting', perm: 'system-config'},
        children: [
          {
            path: '/system/trace/config',
            component: () => import('./components/system/codeAccess/index.vue'),
            meta: {moduleId: 'system', title: '货品追溯权限分配', perm: 'code-access-query'}
          },
          {
            path: '/system/role',
            component: () => import('./components/system/role/index.vue'),
            meta: {moduleId: 'system', title: '角色管理', perm: 'access-role-watch'}
          },
          {
            path: '/system/user',
            component: () => import('./components/system/user/index.vue'),
            meta: {moduleId: 'system', title: '账户管理', perm: 'mdm-manufacture-oms-org-user-watch'}
          },
          {
            path: '/system/log',
            component: () => import('./components/system/log/index.vue'),
            meta: {moduleId: 'system', title: '系统日志', perm: 'system-setting-log'}
          },
          {
            path: '/data/push/log',
            component: () => import('./components/data-xml-log/list.vue'),
            meta: {moduleId: 'system', title: '数据集推送日志', perm: 'bsp-xtpt-log-query'}
          },
          {
            path: '/system/importExport/result',
            component: () => import('./components/system/downloadResult/DownloadResult'),
            meta: {moduleId: 'system', title: '导入导出结果', perm: 'bsp-download-result-query'}
          }
        ]
      }
    ]
  }
];

export const basicRoutes = [
  {path: '/404', component: () => import('./components/error/error_404.vue')},
  {path: '/500', component: () => import('./components/error/error_500.vue')},
  {path: '/login', component: () => import('./components/login/login.vue')},
  {path: '/forget', component: () => import('./components/login/forget.vue')},
  {path: '/resetpsw', component: () => import('./components/login/resetpsw.vue')},
  {path: '/code/:id', component: () => import('./components/login/resetpwd.vue')},
  {path: '/entrance', component: () => import('./components/entrance.vue')}
];

export const ErrorPage = [
  {path: '*', component: () => import('./components/error/error_404.vue')}
];
